import { FC } from 'react'

import { Logo } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../app/_components/navigation/NextLink'
import { useSession } from '../../../app/_providers/SessionProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'

import { LogoBody } from './styles'

export const NavLogo: FC = () => {
  const {
    magnolia: { navigation: strings },
  } = useTranslation()
  const {
    attributes: { stylePreference },
  } = useSession()

  const href = stylePreference ? `/pages/${stylePreference}-home` : '/'

  return (
    <LogoBody>
      <NextLink href={href} title={strings.logoTitle} aria-label={strings.logoTitle}>
        <Logo fill={'currentColor'} aria-hidden='true' />
      </NextLink>
    </LogoBody>
  )
}
